module.exports = __webpack_public_path__ + "static/media/0091_Small.8c9afcf0.jpg";